import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { type VendorDetailsInterface } from 'features/Enterprise/Vendor/types/VendorManagement'

export const SLICE_NAME = 'principalReview'

interface PrincipalRequestDataInterface extends VendorDetailsInterface {
  status: string
  reason: string
}

interface PrincipalReviewStateInterface {
  isLoading: boolean
  principalDetails: PrincipalRequestDataInterface
}

const initialState: PrincipalReviewStateInterface = {
  isLoading: false,
  principalDetails: {} as PrincipalRequestDataInterface,
}

const principalReview = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setPrincipalDetails: (state, action: PayloadAction<PrincipalRequestDataInterface>) => {
      state.principalDetails = action.payload
    },
  },
})

export const { setLoading, setPrincipalDetails } = principalReview.actions

export default principalReview.reducer
